import { IFetchRecurlyCouponPayload, getShouldFetchActiveCoupon } from ".";
import { call, cancel, put, select, takeEvery } from "redux-saga/effects";

import { Cookie } from "constants/cookies";
import { getCookie, removeCookie } from "helpers/cookies";
import { buildPlanCode } from "helpers/subscription";
import { COUPON_COOKIE_OPTIONS } from "helpers/subscription-plans";
import { ApiManager } from "services/api";
import Recurly from "services/recurly";
import { IActionWithPayload } from "store/helper";

import { RequestAction } from "../actions";
import { ISubscription, selectCurrentSubscription } from "../subscriptions";

import { RECURLY, RecurlyActionNames, RecurlyActions } from "./actions";
import {
  ICheckRecurlyCouponPayload,
  IRecurlyCoupon,
  IRecurlyCouponRedemption,
  RecurlyCouponDuration,
  RecurlyCouponType,
} from "./interfaces";

const checkCoupon = (
  couponName: string,
  couponRedemptions: IRecurlyCouponRedemption[],
  planCode: string,
  agents: number
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) => Recurly.checkCoupon(couponName, couponRedemptions, planCode, agents);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function deserializeCoupon(data: any): IRecurlyCoupon {
  return {
    code: data.coupon_code,
    discount: {
      type: RecurlyCouponType.Percent,
      value: data.discount_percent,
      suffixValue: `${data.discount_percent}%`,
    },
    duration: RecurlyCouponDuration.SingleUse,
    redeemed: true,
    redemptions: data.redemptions,
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* checkRecurlyCouponSaga(action: IActionWithPayload<string, ICheckRecurlyCouponPayload>) {
  const { couponName, couponRedemptions, planCode, agents } = action.payload;

  try {
    // @ts-expect-error TS(2769)
    const response: IRecurlyCoupon = yield call(checkCoupon, couponName, couponRedemptions, planCode, agents);
    yield put(RecurlyActions.checkRecurlyCouponSuccess({ id: couponName, value: response }));
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    yield put(RecurlyActions.checkRecurlyCouponFailure({ id: couponName, error: null }));
    yield cancel();
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchCoupon(action: IActionWithPayload<string, IFetchRecurlyCouponPayload>) {
  const shouldFetchActiveCoupon: boolean = yield select(getShouldFetchActiveCoupon);
  const subscription: ISubscription = yield select(selectCurrentSubscription);

  if (shouldFetchActiveCoupon) {
    // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    const response = yield call(ApiManager.billingApi.fetchCoupon);

    const activeCouponsWithoutFreeTrialCoupons = response.result
      ? response.result.filter(
          (coupon: { discount_type: "free_trial" | "fixed_amount" | "percentage" }) =>
            coupon.discount_type !== "free_trial"
        )
      : [];

    if (!activeCouponsWithoutFreeTrialCoupons.length) {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
      yield put(RecurlyActions.fetchCouponFailure({ id: null, error: null }));
    } else {
      const coupon = deserializeCoupon(activeCouponsWithoutFreeTrialCoupons[0]);
      const planCode = buildPlanCode(subscription.plan, subscription.billingCycle);

      try {
        // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
        const result = yield call(checkCoupon, coupon.code, coupon.redemptions, planCode, subscription.agents);
        yield put(RecurlyActions.fetchCouponSuccess({ id: coupon.code, value: result }));
        removeCookie(Cookie.CouponCode);
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
        yield put(RecurlyActions.fetchCouponFailure({ id: null, error: null }));
      }
    }
  }

  const coupon = getCookie(Cookie.CouponCode);

  if (coupon) {
    yield put(
      RecurlyActions.checkRecurlyCoupon({
        couponName: coupon,
        planCode: action.payload.planCode,
        agents: action.payload.agents,
      })
    );
  }
}

// eslint-disable-next-line require-yield, @typescript-eslint/explicit-function-return-type
function* removeRecurlyCoupon() {
  removeCookie(Cookie.CouponCode, COUPON_COOKIE_OPTIONS);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* recurlySaga() {
  yield takeEvery(RECURLY.COUPONS[RequestAction.REQUEST], fetchCoupon);
  yield takeEvery([RecurlyActionNames.CHECK_RECURLY_COUPON_REQUEST], checkRecurlyCouponSaga);
  yield takeEvery([RecurlyActionNames.COUPON_REDEEMED], removeRecurlyCoupon);
}
